import React from "react";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import CloseIcon from "@mui/icons-material/Close";
import "./profile-image-upload.scss";
import AvatarIcon from "../../../assets/icons/avatar.svg"

interface ProfileImageUploadProps {
  imageUrl?: string; // existing image (leadDetails?.lead_profile_file_Url)
  uploadedImage?: string | null; // preview image
  onImageUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveImage: () => void;
  viewFullInfoOpen: boolean;
  placeholderImage: string;
  disableEditIcon?: boolean;
}

const ProfileImageUploadComponent: React.FC<ProfileImageUploadProps> = ({
  imageUrl,
  uploadedImage,
  onImageUpload,
  onRemoveImage,
  viewFullInfoOpen,
  placeholderImage,
  disableEditIcon = false,
}) => {
  const showAvatarOnly = !uploadedImage && !imageUrl;
  const finalImage = uploadedImage || imageUrl || placeholderImage;

  return (
    <div className="profile-container">
      <img src={finalImage} alt="profile-pic" className="footer-icon" />

      {viewFullInfoOpen && (
        <>
          {/* Show close icon in these two cases */}
          {(uploadedImage || imageUrl) && (
            <div className={`close-image ${disableEditIcon ? 'disable-icon' : ''}`}
              onClick={(e) => {
              if(disableEditIcon) e.preventDefault()
              else onRemoveImage()
            }}>
              <CloseIcon className="cancel-icon" />
            </div>
          )}

          {/* Show edit icon only if placeholder is shown (i.e. both imageUrl and uploadedImage are gone) */}
          {showAvatarOnly && (
            <>
              <div
                className={`edit-overlay ${disableEditIcon ? 'disable-icon' : ''}`}
                onClick={(e) => {
                  if(disableEditIcon) e.preventDefault()
                  else document.getElementById("upload-input")?.click()
                }
                }
              >
                <ModeEditOutlinedIcon className="edit-icon" />
              </div>
              <input
                type="file"
                id="upload-input"
                accept="image/*"
                style={{ display: "none" }}
                onChange={onImageUpload}
              />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default ProfileImageUploadComponent;
